import { createContext, useContext, ReactNode } from 'react';
import type { SchedulerStatus } from '@repo/types';
import { isComponentVisible } from '../../utils/schedulerVisibility';

export type { SchedulerStatus };
export { isComponentVisible };

const SchedulerContext = createContext<SchedulerStatus | null>(null);

export const SchedulerProvider = ({ children, status }: { children: ReactNode; status: SchedulerStatus | null }) => {
  return <SchedulerContext.Provider value={status}>{children}</SchedulerContext.Provider>;
};

export const useSchedulerStatus = () => {
  return useContext(SchedulerContext);
};
